import { checkIsFreemiumPlan } from 'helper/checkPlan.helper';

const { useSelector } = require('react-redux');

const FreemiumPlanWrapper = ({ children }) => {
    const { companyData } = useSelector((params) => params.customization);

    return <>{companyData && checkIsFreemiumPlan(companyData?.subscription?.plan) ? children : ''}</>;
};
export default FreemiumPlanWrapper;
